export const etalonnageModel = {
    label: 'Etalonnage',
    tableName: 'calibration',
    properties: [
        {
            label: 'Espèce',
            id: 'species',
            isForeignKey: true,
            column_name: 'name', // Recherche la correspondance par nom d'espèce
            table_column: 'specie_id', // Stockera l'ID trouvé
            type: 'text',
            example: 'Rhizophora mucronata', // Exemple d'espèce de mangrove
            required: true
        },
        {
            label: 'Unité',
            id: 'unity',
            type: 'text',
            example: 'kg', // Ou 'Sachet', 'Plants', etc.
            required: true
        },
        {
            label: 'Quantité',
            id: 'value',
            type: 'text',
            example: '100', // Correspond au type Int dans Prisma
            required: true
        }
    ]
}
